import {
  BackgroundType,
  CoursizStrategy,
  ETrainerRights,
  Font,
  FrontDynamicParams,
  LicenceThresholdType,
  LocaleEnum,
  User,
  UserTypes,
} from '@jump-tools-front/shared-interfaces';

export const mockedUser: User = {
  createdAt: new Date('2017-07-30T17:53:02+02:00'),
  updatedAt: new Date('2023-07-30T17:53:02+02:00'),
  identifier: 'jump_morgan@jump-biz.com',
  id: 4208,
  email: '4208@test.fr',
  matriculeRh: '',
  matriculeAd: null,
  firstname: 'Morgan',
  lastname: 'Nicol',
  valid: true,
  active: true,
  admitted: null,
  type: UserTypes.ADMIN_SUP,
  temporaryPassword: false,
  roles: [
    'ACCESS_BO',
    'FO',
    'JUMP',
    'SWITCH_FO',
    'CLIENT_CREATE_SAP',
    'CLIENT_LISTING',
    'CLIENT_LISTING_OWN',
    'CLIENT_CREATE',
    'CLIENT_CREATE_JUMP',
    'CLIENT_CREATE_ENTREPRISE_FO',
    'CLIENT_CREATE_ENTREPRISE_BO',
    'CLIENT_CREATE_ENTREPRISE_BOFO',
    'CLIENT_SHOW',
    'CLIENT_SHOW_OWN',
    'CLIENT_SHOW_CURRENT',
    'CLIENT_EDIT',
    'CLIENT_EDIT_CURRENT',
    'CLIENT_DELETE',
    'CLIENT_CREATE_SIGNATURE',
    'CLIENT_SWITCH_CLIENT',
    'CLIENT_CREATE_PICTO',
    'CLIENT_SIGNATURE_USE',
    'CLIENT_CREATE_SIGNATURE_CURRENT',
    'CLIENT_SHOW_SIGNATURE_CURRENT',
    'CLIENT_SHOW_SIGNATURE',
    'CLIENT_AFFECTATION_LISTING',
    'USER_LISTING',
    'USER_CREATE',
    'USER_CREATE_ADMIN++',
    'USER_CREATE_ADMIN',
    'USER_CREATE_MANAGER',
    'USER_CREATE_FORMATEUR',
    'USER_CREATE_APPRENANT',
    'USER_SHOW',
    'USER_SHOW_OWN',
    'USER_EDIT',
    'USER_EDIT_ADMIN++',
    'USER_EDIT_OWN',
    'USER_EDIT_CURRENT',
    'USER_DELETE',
    'USER_DELETE_OWN',
    'USER_CLIENT_SIGNATURE_USE',
    'USER_CLIENT_SIGNATURE_SHOW',
    'USER_CLIENT_LOGO_CREATE',
    'USER_PRODUCT_LISTING',
    'USER_PRODUCT_OWN',
    'USER_MEAN_LISTING',
    'USER_MEAN_LISTING_OWN',
    'USER_PRODUCT_READ_OTHERS',
    'USER_IMPERSONATE',
    'USER_IMPORT',
    'USER_EXPERT',
    'PRODUCT_CREATE_GAME',
    'PRODUCT_SCORM_EXPORT',
    'PRODUCT_CREATE_LEARNIZ',
    'PRODUCT_CREATE_COURSIZ',
    'PRODUCT_CREATE_CLASSIZ',
    'PRODUCT_CREATE_ATTACHMENT',
    'PRODUCT_CREATE_SCORM',
    'PRODUCT_CREATE_SURVEY',
    'PRODUCT_LINK_GAME',
    'PRODUCT_LINK_LEARNIZ',
    'PRODUCT_LINK_COURSIZ',
    'PRODUCT_LINK_CLASSIZ',
    'PRODUCT_LINK_ATTACHMENT',
    'PRODUCT_LINK_SCORM',
    'PRODUCT_LINK_SURVEY',
    'PRODUCT_PREVIEW_GAME',
    'PRODUCT_PREVIEW_LEARNIZ',
    'PRODUCT_PREVIEW_SCORM',
    'PRODUCT_DRAFT_GAME',
    'PRODUCT_DRAFT_LEARNIZ',
    'PRODUCT_DRAFT_COURSIZ',
    'PRODUCT_DRAFT_CLASSIZ',
    'PRODUCT_DRAFT_ATTACHMENT',
    'PRODUCT_DRAFT_SCORM',
    'PRODUCT_DRAFT_SURVEY',
    'PRODUCT_DUPLICATE_GAME',
    'PRODUCT_DUPLICATE_LEARNIZ',
    'PRODUCT_DUPLICATE_COURSIZ',
    'PRODUCT_DUPLICATE_CLASSIZ',
    'PRODUCT_DUPLICATE_ATTACHMENT',
    'PRODUCT_DUPLICATE_SCORM',
    'PRODUCT_DUPLICATE_SURVEY',
    'PRODUCT_PUBLISH_GAME',
    'PRODUCT_PUBLISH_LEARNIZ',
    'PRODUCT_PUBLISH_COURSIZ',
    'PRODUCT_PUBLISH_CLASSIZ',
    'PRODUCT_PUBLISH_ATTACHMENT',
    'PRODUCT_PUBLISH_SCORM',
    'PRODUCT_PUBLISH_SURVEY',
    'PRODUCT_EDIT_GAME',
    'PRODUCT_EDIT_LEARNIZ',
    'PRODUCT_EDIT_COURSIZ',
    'PRODUCT_EDIT_CLASSIZ',
    'PRODUCT_EDIT_ATTACHMENT',
    'PRODUCT_EDIT_SCORM',
    'PRODUCT_EDIT_SURVEY',
    'PRODUCT_LISTING_GAME',
    'PRODUCT_LISTING_LEARNIZ',
    'PRODUCT_LISTING_COURSIZ',
    'PRODUCT_LISTING_CLASSIZ',
    'PRODUCT_LISTING_ATTACHMENT',
    'PRODUCT_LISTING_SCORM',
    'PRODUCT_LISTING_SURVEY',
    'PRODUCT_SHOW_GAME',
    'PRODUCT_SHOW_LEARNIZ',
    'PRODUCT_SHOW_COURSIZ',
    'PRODUCT_SHOW_CLASSIZ',
    'PRODUCT_SHOW_ATTACHMENT',
    'PRODUCT_SHOW_SCORM',
    'PRODUCT_SHOW_SURVEY',
    'PRODUCT_CREATE_SSO',
    'PRODUCT_READ',
    'PRODUCT_READ_OWN',
    'PRODUCT_UPDATE_OWN',
    'PRODUCT_DELETE_OWN',
    'PRODUCT_PUBLISH_OWN',
    'PRODUCT_DIFFUSE_SCORM',
    'PRODUCT_DIFFUSE_WEB',
    'PRODUCT_SHARE',
    'PRODUCT_SHARE_OWN',
    'DOCUMENT_LISTING',
    'DOCUMENT_LISTING_PARAMS',
    'DOCUMENT_EDIT',
    'DOCUMENT_EDIT_PARAMS',
    'DOCUMENT_EDIT_SCORM',
    'DOCUMENT_EDIT_TCHAT',
    'STATS_ADMIN_DASHBOARD',
    'STATS_MANAGER_DASHBOARD',
    'MEAN_LISTING',
    'MEAN_CREATE',
    'MEAN_EDIT',
    'MEAN_SHOW',
    'MEAN_DELETE',
    'MEAN_PUBLISH',
    'MEAN_ZIP_ATTESTATIONS',
    'UPDATE_DEFAULT_FAQ',
    'UPDATE_OWN_FAQ',
    'VIEW_ALL_CLIENTS_FAQ',
    'VIEW_OWN_FAQ',
    'DELETE_DEFAULT_FAQ',
    'DELETE_OWN_FAQ',
    'UPDATE_DEFAULT_TEMPLATES',
    'UPDATE_TEMPLATES',
    'IMPERSONATE_CLIENT',
    'ADD_EDIT_LICENCE',
  ],
  locale: LocaleEnum.FR,
  manager: null,
  access: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'front-dynamic': 'https://jump.front-dynamic.staging.storiz.jump-biz.fr',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'back-office': 'https://jump.back-office.staging.storiz.jump-biz.fr',
  },
  hasAcceptedCgu: true,
  lastLogin: new Date('2023-03-28T17:53:02+02:00'),
  trainerMeans: [
    { meanName: 'Armin session', meanSlug: 'armin', sessionDroit: ETrainerRights.WRITE },
    { meanName: 'Ferry session', meanSlug: 'ferry', sessionDroit: ETrainerRights.READ },
  ],
  client: {
    id: 1,
    slug: 'jump',
    name: 'Jump',
    active: true,
    address: '37 rue des Marchands',
    addressAdditional: '',
    postalCode: '31000',
    country: 'France',
    logo: 'https://admin.storiz-biz.com/uploads/document/lkd8gf5bk60v365klp89q6u8rdwte8/lkd8gf5bk60v365klp89q6u8rdwte8.png',
    signatureInfo:
      'JUMP Sociéte par actions simplifiée au capital de 93.125 € Siège social : 37 rue des Marchands 31000 Toulouse 494 593 486 R.C.S. Toulouse Suivant procès-verbal en date du 7 juillet 2020 l’assemblée générale mixte décide d’augmenter le capital social d’une somme de 9.313 € afin de le porter de 93.125 € à 102.438 €',
    type: 'JUMP',
    tags: [{ name: 'Tag1', slug: 'fdsfdgfgrgthjgdjdqskrfjmds' }],
    roles: [
      'ACCESS_BO',
      'FO',
      'JUMP',
      'SWITCH_FO',
      'CLIENT_CREATE_SAP',
      'CLIENT_LISTING',
      'CLIENT_LISTING_OWN',
      'CLIENT_CREATE',
      'CLIENT_CREATE_JUMP',
      'CLIENT_CREATE_ENTREPRISE_FO',
      'CLIENT_CREATE_ENTREPRISE_BO',
      'CLIENT_CREATE_ENTREPRISE_BOFO',
      'CLIENT_SHOW',
      'CLIENT_SHOW_OWN',
      'CLIENT_SHOW_CURRENT',
      'CLIENT_EDIT',
      'CLIENT_EDIT_CURRENT',
      'CLIENT_DELETE',
      'CLIENT_CREATE_SIGNATURE',
      'CLIENT_SWITCH_CLIENT',
      'CLIENT_CREATE_PICTO',
      'CLIENT_SIGNATURE_USE',
      'CLIENT_CREATE_SIGNATURE_CURRENT',
      'CLIENT_SHOW_SIGNATURE_CURRENT',
      'CLIENT_SHOW_SIGNATURE',
      'CLIENT_AFFECTATION_LISTING',
      'USER_LISTING',
      'USER_CREATE',
      'USER_CREATE_ADMIN++',
      'USER_CREATE_ADMIN',
      'USER_CREATE_MANAGER',
      'USER_CREATE_FORMATEUR',
      'USER_CREATE_APPRENANT',
      'USER_SHOW',
      'USER_SHOW_OWN',
      'USER_EDIT',
      'USER_EDIT_ADMIN++',
      'USER_EDIT_OWN',
      'USER_EDIT_CURRENT',
      'USER_DELETE',
      'USER_DELETE_OWN',
      'USER_CLIENT_SIGNATURE_USE',
      'USER_CLIENT_SIGNATURE_SHOW',
      'USER_CLIENT_LOGO_CREATE',
      'USER_PRODUCT_LISTING',
      'USER_PRODUCT_OWN',
      'USER_MEAN_LISTING',
      'USER_MEAN_LISTING_OWN',
      'USER_PRODUCT_READ_OTHERS',
      'USER_IMPERSONATE',
      'USER_IMPORT',
      'USER_COLLABORATOR_LISTING',
      'USER_EXPERT',
      'PRODUCT_CREATE_GAME',
      'PRODUCT_SCORM_EXPORT',
      'PRODUCT_CREATE_LEARNIZ',
      'PRODUCT_CREATE_COURSIZ',
      'PRODUCT_CREATE_CLASSIZ',
      'PRODUCT_CREATE_ATTACHMENT',
      'PRODUCT_CREATE_SCORM',
      'PRODUCT_CREATE_SURVEY',
      'PRODUCT_LINK_GAME',
      'PRODUCT_LINK_LEARNIZ',
      'PRODUCT_LINK_COURSIZ',
      'PRODUCT_LINK_CLASSIZ',
      'PRODUCT_LINK_ATTACHMENT',
      'PRODUCT_LINK_SCORM',
      'PRODUCT_LINK_SURVEY',
      'PRODUCT_PREVIEW_GAME',
      'PRODUCT_PREVIEW_LEARNIZ',
      'PRODUCT_PREVIEW_SCORM',
      'PRODUCT_DRAFT_GAME',
      'PRODUCT_DRAFT_LEARNIZ',
      'PRODUCT_DRAFT_COURSIZ',
      'PRODUCT_DRAFT_CLASSIZ',
      'PRODUCT_DRAFT_ATTACHMENT',
      'PRODUCT_DRAFT_SCORM',
      'PRODUCT_DRAFT_SURVEY',
      'PRODUCT_DUPLICATE_GAME',
      'PRODUCT_DUPLICATE_LEARNIZ',
      'PRODUCT_DUPLICATE_COURSIZ',
      'PRODUCT_DUPLICATE_CLASSIZ',
      'PRODUCT_DUPLICATE_ATTACHMENT',
      'PRODUCT_DUPLICATE_SCORM',
      'PRODUCT_DUPLICATE_SURVEY',
      'PRODUCT_PUBLISH_GAME',
      'PRODUCT_PUBLISH_LEARNIZ',
      'PRODUCT_PUBLISH_COURSIZ',
      'PRODUCT_PUBLISH_CLASSIZ',
      'PRODUCT_PUBLISH_ATTACHMENT',
      'PRODUCT_PUBLISH_SCORM',
      'PRODUCT_PUBLISH_SURVEY',
      'PRODUCT_EDIT_GAME',
      'PRODUCT_EDIT_LEARNIZ',
      'PRODUCT_EDIT_COURSIZ',
      'PRODUCT_EDIT_CLASSIZ',
      'PRODUCT_EDIT_ATTACHMENT',
      'PRODUCT_EDIT_SCORM',
      'PRODUCT_EDIT_SURVEY',
      'PRODUCT_LISTING_GAME',
      'PRODUCT_LISTING_LEARNIZ',
      'PRODUCT_LISTING_COURSIZ',
      'PRODUCT_LISTING_CLASSIZ',
      'PRODUCT_LISTING_ATTACHMENT',
      'PRODUCT_LISTING_SCORM',
      'PRODUCT_LISTING_SURVEY',
      'PRODUCT_SHOW_GAME',
      'PRODUCT_SHOW_LEARNIZ',
      'PRODUCT_SHOW_COURSIZ',
      'PRODUCT_SHOW_CLASSIZ',
      'PRODUCT_SHOW_ATTACHMENT',
      'PRODUCT_SHOW_SCORM',
      'PRODUCT_SHOW_SURVEY',
      'PRODUCT_CREATE_SSO',
      'PRODUCT_READ',
      'PRODUCT_READ_OWN',
      'PRODUCT_UPDATE_OWN',
      'PRODUCT_DELETE_OWN',
      'PRODUCT_PUBLISH_OWN',
      'PRODUCT_DIFFUSE_SCORM',
      'PRODUCT_DIFFUSE_WEB',
      'PRODUCT_SHARE',
      'PRODUCT_SHARE_OWN',
      'DOCUMENT_LISTING',
      'DOCUMENT_LISTING_PARAMS',
      'DOCUMENT_EDIT',
      'DOCUMENT_EDIT_PARAMS',
      'DOCUMENT_EDIT_SCORM',
      'DOCUMENT_EDIT_TCHAT',
      'STATS_ADMIN_DASHBOARD',
      'STATS_MANAGER_DASHBOARD',
      'MEAN_LISTING',
      'MEAN_CREATE',
      'MEAN_EDIT',
      'MEAN_SHOW',
      'MEAN_DELETE',
      'MEAN_PUBLISH',
      'MEAN_ZIP_ATTESTATIONS',
      'UPDATE_DEFAULT_FAQ',
      'UPDATE_OWN_FAQ',
      'VIEW_ALL_CLIENTS_FAQ',
      'VIEW_OWN_FAQ',
      'DELETE_DEFAULT_FAQ',
      'DELETE_OWN_FAQ',
      'UPDATE_DEFAULT_TEMPLATES',
      'UPDATE_TEMPLATES',
      'IMPERSONATE_CLIENT',
      'ADD_EDIT_LICENCE',
    ],
    city: 'Toulouse',
    picto: null,
    endLicence: new Date('2030-12-17T13:22:51+01:00'),
    params: {
      palette: {
        name: 'grapefruit',
        darkColor: '#173640',
        lightColor: '#ffffff',
        primaryColor: '#E4595B',
      },
      mainFont: {
        family: 'Montserrat',
      },
      strategy: CoursizStrategy.DEFAULT,
      faviconUrl: null,
      gameParams: {
        soundUrl: {
          src: null,
        },
        portraitUrl: {
          alt: null,
          src: './assets/shared/images/game-background/avatar/full-1.jpg',
          type: BackgroundType.IMAGE,
          right: null,
        },
        customSounds: [],
        backgroundUrl: {
          alt: null,
          src: './assets/shared/images/game-background/pattern/pink-blue.jpg',
          type: BackgroundType.IMAGE,
          right: null,
        },
        customMainImages: [],
        customPortraitImages: [],
      },
      customFonts: [],
      hidePrivacy: false,
      customColors: [],
      learnizParams: {
        fontTitle: new Font(),
        customSounds: [],
        slideBackground: {
          alt: 'vertex',
          src: './assets/shared/lotties/LOTTIE_VERTEX_01.json',
          type: BackgroundType.LOTTIE,
          right: null,
        },
        customMainImages: [],
        customMenuImages: [],
        customSlideImages: [],
        customPortraitImages: [],
        landingBackgroundImages: {
          main: {
            alt: 'univers',
            src: './assets/shared/images/main-background/univers.jpg',
            type: BackgroundType.IMAGE,
            right: null,
          },
          menu: {
            alt: 'vertex',
            src: './assets/shared/lotties/LOTTIE_VERTEX_01.json',
            type: BackgroundType.LOTTIE,
            right: null,
          },
        },
      },
      hideHelpLearniz: false,
      customFaviconUrl: [],
      coursizBackground: {
        alt: 'univers',
        src: './assets/shared/images/main-background/univers.jpg',
        type: BackgroundType.IMAGE,
        right: null,
      },
      frontDynamicParams: new FrontDynamicParams(),
      isChatExpertEnabled: true,
      coursizCustomBackgroundImages: [],
    },
    createdAt: new Date('2020-01-10T16:04:46+01:00'),
    updatedAt: new Date('2023-03-27T12:11:47+02:00'),
    locale: 'fr_FR',
    hasSignature: true,
    wsDocument: null,
    contact: 'guillaume@jump-biz.com',
    licenceContent: {
      licences: [
        {
          licenceInformation: {
            count: [
              {
                unity: LicenceThresholdType.NB_USER,
                quantity: 1828,
              },
              {
                unity: LicenceThresholdType.NB_CLIENT,
                quantity: 16,
              },
              {
                unity: LicenceThresholdType.NB_EDITOR,
                quantity: 63,
              },
              {
                unity: LicenceThresholdType.STOCKAGE,
                quantity: 910831075167,
              },
            ],
            licence: [
              {
                unity: LicenceThresholdType.NB_USER,
                quantity: 1000000,
              },
              {
                unity: LicenceThresholdType.NB_CLIENT,
                quantity: 1000000,
              },
              {
                unity: LicenceThresholdType.NB_EDITOR,
                quantity: 1000,
              },
              {
                unity: LicenceThresholdType.STOCKAGE,
                quantity: 50000000000000,
              },
            ],
          },
        },
      ],
      demo: false,
    },
    hasSubClients: true,
    clients: null,
    numberClients: null,
    formules: null,
    ssoTracking: false,
    config: {
      importAuto: true,
    },
  },
};
